import styled from 'styled-components'

import BootstrapModalBody from 'react-bootstrap/lib/ModalBody'

export const ModalBody = styled(BootstrapModalBody)`
  padding: 0;
  margin: 0 40px;

  .modal-error-line {
    margin: 10px 0;
    border-top: 1px solid #ccc;
    padding-top: 10px;

    p {
      font-size: 13px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Modal/ModalBody/index.js